import routes from "../common/api-routes";
import {HttpAuthGet} from "../../../../core/services/common/HttpRequestBuilder";

const getProfilePermissions = (profile_uid) => {
    let result = HttpAuthGet(routes.GET_PROFILE_PERMISSION, null, null, profile_uid);
    return result;
}

const getRoleByProfileType = (parameters) => {
    let result = HttpAuthGet(routes.GET_ROLE_BY_PROFILE_TYPE, parameters);
    return result;
}

const RBACService = {
    getProfilePermissions,
    getRoleByProfileType
}

export default RBACService


